// extracted by mini-css-extract-plugin
export default {"root":"iW8Rt1xjzjUGdee0KUwM","trunc":"CThUFYd7VTCkdtzhQByg"};